module.exports = __webpack_public_path__ + "static/media/Dragon-Scales.62ad27f9.svg";